// extracted by mini-css-extract-plugin
export default {"sideInformation":"sideInformation_sideInformation__p1sNt"};